import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import User from '../../../../assets/Images/user.svg';

// icon imports
import { BiStore } from 'react-icons/bi';
import { TbLogout } from "react-icons/tb";
// end

import { useNavigate } from 'react-router';
import { useContext } from 'react';
import { StorePopup } from '../../../../Context';
import atoms from '../../../atoms';
import { useLogic } from '../useLogic';
import { StoreListType } from '../interface';

const { Image } = atoms

export const UserMenu: React.FC<{ storeList: StoreListType }> = ({ storeList }) => {
  const [isShow, setIsShow] = useContext<any>(StorePopup);
  const { logout, toggleDropdown, setToggleDropdown } = useLogic();

  const navigate = useNavigate()

  return (
    <Dropdown group isOpen={toggleDropdown} size="lg" toggle={() => setToggleDropdown(!toggleDropdown)}>
      <DropdownToggle className='dropdown-button-hide cursor-pointer'>
        <Image className='header-user-icon-width' src={User} />
      </DropdownToggle>
      <DropdownMenu style={{ minWidth: '12rem' }}>
        {storeList.length > 1 && (
          <div className='p-0 d-flex header-dropdown align-items-center gap-1 ps-3'>
            <BiStore />
            <span className='cursor-pointer  p-2' onClick={() => setIsShow(true)}>Select Store</span>
          </div>
        )}
        <div className='p-0 d-flex header-dropdown align-items-center gap-1 ps-3'>
          <TbLogout />
          <span className='cursor-pointer  p-2' onClick={() => navigate('/change-password')}>Change password</span>
        </div>
        <div className='p-0 d-flex header-dropdown align-items-center gap-1 ps-3'>
          <TbLogout />
          <span className='cursor-pointer  p-2' onClick={() => logout()}>Logout</span>
        </div>
      </DropdownMenu>
    </Dropdown>
  )
}